var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { isEqual } from 'lodash';
import { ELSCommonConfig, ELSNewRelicBrowserService } from '@els/els-ui-common-react';
import { PageNamePrefixes } from 'constants/app.constant';
// TODO: Fix
/**
 * This is a workaround while waiting the official release.
 * Helmet uses deep-equal and sometimes crashes on circular objects.
 * See: https://github.com/nfl/react-helmet/issues/373
 * The fix is in 6.x beta. Wait for official release
 */
Helmet.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
};
var withHTMLHeadSEO = function (data) {
    if (data === void 0) { data = {}; }
    return function (BaseComponent) {
        var SEOComponent = /** @class */ (function (_super) {
            __extends(SEOComponent, _super);
            function SEOComponent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            SEOComponent.prototype.render = function () {
                var headScripts = [];
                try {
                    // eslint-disable-next-line no-undef
                    var _a = JSON.parse(getNewRelicBrowserConfig()), licenseKey = _a.licenseKey, applicationID = _a.applicationID;
                    if (licenseKey && applicationID) {
                        headScripts.push({
                            type: 'text/javascript',
                            innerHTML: ELSNewRelicBrowserService.registerNewRelicBrowser({ licenseKey: licenseKey, applicationID: applicationID })
                        });
                    }
                }
                catch (e) {
                    ELSCommonConfig.getLogger().debug('New Relic Browser is not enabled for the current environment');
                }
                var pageNamePrefix = data.pageNamePrefix || PageNamePrefixes.cw;
                var title = data && data.title ? "".concat(pageNamePrefix, " - ").concat(data.title) : pageNamePrefix;
                return (<div>
          <Helmet title={title} script={headScripts}>
            <html lang="en"/>
          </Helmet>
          {BaseComponent && <BaseComponent {...this.props}/>}
        </div>);
            };
            return SEOComponent;
        }(PureComponent));
        return SEOComponent;
    };
};
export default withHTMLHeadSEO;
